import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, HStack, colors } from '@rtkwlf/fenrir-react';
import { faChevronRight } from '@rtkwlf/pro-solid-svg-icons/faChevronRight';
import { Link } from 'react-router-dom';

import styles from './breadcrumbs.module.css';
import { usePageMeta } from './page-meta-provider';

type Breadcrumb = {
  type: 'intl' | 'dynamic';
  title: string;
  href: string;
  disabled?: boolean;
};

const Breadcrumbs: React.FunctionComponent = () => {
  /**
   * Subscribe to page meta context
   */
  const { crumbs } = usePageMeta();

  const INACTIVE_TAB_INDEX = -1;

  if (crumbs.length === 0) {
    return null;
  }

  return (
    <nav aria-label="Breadcrumb" className={styles['breadcrumbs']}>
      <HStack yAlign="center">
        <ul className={styles.crumbList}>
          {crumbs.map((crumb, index: number) => {
            const isLastCrumb = index === crumbs.length - 1;
            return (
              <React.Fragment key={index}>
                <Link
                  to={crumb.href}
                  key={crumb.href}
                  aria-current={isLastCrumb ? 'page' : undefined}
                  className={styles.crumb}
                  data-disabled={crumb.disabled}
                >
                  <Button
                    variant="link"
                    margin="zero"
                    paddingBottom="large"
                    isDisabled={crumb.disabled}
                    tabIndex={INACTIVE_TAB_INDEX}
                  >
                    {crumb.title}
                  </Button>
                </Link>
                {!isLastCrumb && (
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    color={`rgb(${colors.icon.neutral.default})`}
                    transform="shrink-4"
                  />
                )}
              </React.Fragment>
            );
          })}
        </ul>
      </HStack>
    </nav>
  );
};

export { Breadcrumbs };
export type { Breadcrumb };
